import { render } from "./EditInstrument.vue?vue&type=template&id=27124c7f&scoped=true"
import script from "./EditInstrument.vue?vue&type=script&lang=js"
export * from "./EditInstrument.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-27124c7f"

export default script